import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {UserInfoModel} from '../services/models/user-info.model';
import {UserService} from '../services/user.service';


@Injectable({ providedIn: 'root' })
export class UserInfoResolver implements Resolve<UserInfoModel> {
    constructor(private userService: UserService) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<UserInfoModel> {
        if (this.userService.userInfo !== null) {
            return Promise.resolve(this.userService.userInfo);
        }
        return this.userService.getUserInfo();
    }
}
